import { useSelector } from "react-redux"
import { SecondThreeSection, ColumnWrapper, ColumnHeader, ColumnBodyText, ColumnImage, LearnMore } from "./SecondThreeColumnsStyle"
import image4 from "./01_images/column4.jpg"
import image5 from "./01_images/column5.jpg"
import image6 from "./01_images/column6.jpg"
import { about } from "../../../i18n/03_about"

const SecondThreeColumns = () => {
    const lang = useSelector(state => state.lang.lang)
    const t = about[lang]
    const secondImages = [image4, image5, image6]

    return (
        <SecondThreeSection>

            {t.secondColumnWrapper.map((value, index) => (
                    <ColumnWrapper key={index}>
                        <ColumnImage src={secondImages[index]} />
                        <ColumnHeader>
                            {value.columnHeader}
                        </ColumnHeader>
                        <ColumnBodyText>
                            {value.columnBodyText}
                        </ColumnBodyText>
                        <LearnMore to={value.learnMoreTo}>
                            {value.learnMoreText}
                        </LearnMore>
                    </ColumnWrapper>
            ))}


            {/* <ColumnWrapper>
                <ColumnImage src={image4} />
                <ColumnHeader>
                    LISTEN TO UNDERSTAND
                </ColumnHeader>
                <ColumnBodyText>
                    You have the convenience of pressing Pause or Replay for the texts in this course — something that, unfortunately, isn’t possible in real life. However, you can always ask someone to speak more slowly or repeat what they said. Watch movies in English, listen to the radio, and talk to people as much as you can! You’ll be surprised how quickly you progress with consistent practice.
                </ColumnBodyText>
                <LearnMore to="/listening">
                    Learn More...
                </LearnMore>
            </ColumnWrapper>
            <ColumnWrapper>
                <ColumnImage src={image5} />
                <ColumnHeader>
                    SPEAK WITH CONFIDENCE
                </ColumnHeader>
                <ColumnBodyText>
                    Speaking is best mastered through dialogues — and in this course, you have the perfect opportunity: 30 conversations with your teacher!  In addition, there are 30 texts you’ll practice speaking in English. The conversational topics cover most areas of everyday life. Speaking is the most challenging part of the course, but once you master it, it will give you tremendous confidence!
                </ColumnBodyText>
                <LearnMore to="/speaking">
                    Learn More...
                </LearnMore>
            </ColumnWrapper>
            <ColumnWrapper>
                <ColumnImage src={image6} />
                <ColumnHeader>
                    BRING IT ALL TOGETHER
                </ColumnHeader>
                <ColumnBodyText>
                    You can certainly learn Vocabulary, Grammar, Reading, Listening, and Speaking separately, but the most effective way is to use the My Progress option, which combines them all. Each of the 30 lessons includes a grammar topic with three exercises, 35 new words to learn, two reading texts, two listening texts, one dialogue, and one text to speak in English.
                </ColumnBodyText>
                <LearnMore to="/myprogress">
                    Learn More...
                </LearnMore>
            </ColumnWrapper> */}
        </SecondThreeSection>
    )
}

export default SecondThreeColumns